import { render, staticRenderFns } from "./Trabajos.vue?vue&type=template&id=7c1479ca&scoped=true&"
import script from "./Trabajos.vue?vue&type=script&lang=js&"
export * from "./Trabajos.vue?vue&type=script&lang=js&"
import style0 from "./Trabajos.vue?vue&type=style&index=0&id=7c1479ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1479ca",
  null
  
)

export default component.exports